import firebase from "firebase";
import "firebase/auth";
import "firebase/database";
import "firebase/firestore";

const config = {
  apiKey: "AIzaSyB8kQzIr94SR19pm4ONs-wGFpc-uU1RMSM",
  authDomain: "legioxnew.firebaseapp.com",
  databaseURL: "https://legioxnew.firebaseio.com",
  projectId: "legioxnew",
  storageBucket: "legioxnew.appspot.com",
  messagingSenderId: "811954784795",
  appId: "1:811954784795:web:f19ff35fb49dfc79a646be",
  measurementId: "G-D3ZG85YF3J"
  };

firebase.initializeApp(config);
export const auth = firebase.auth;
export const fdb = firebase.firestore();


// WEBPACK FOOTER //
// ./src/services/firebase.js